import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-badge',
},
  __name: 'badge',
  props: {
  variant: {
    type: String as PropType<'primary' | 'secondary' | 'tertiary' | 'success' | 'danger' | 'default'>,
    default: 'primary',
  },
},
  setup(__props) {



// Define props.
const props = __props;

const badgeClass = computed(() => ({
  'badge--primary': props.variant === 'primary',
  'badge--secondary': props.variant === 'secondary',
  'badge--tertiary': props.variant === 'tertiary',
  'badge--success': props.variant === 'success',
  'badge--danger': props.variant === 'danger',
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["badge", badgeClass.value])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})